<!-- conversationBg -->
<div class="conversationBg">

    <div class="fixed_head">
        <!-- in-playTop -->
        <div class="in-playTop d-flex justify-content-end">
            <div class="btn shadow-none pe-none border-0 bg-transparent"></div>
            <button class="btn" type="button" *ngIf="this.playedHoles.length > 0" (click)="prevHole()">
                {{getHoleNumber('holeNumber', this.playedHoles[0].hole.HoleNumber)}}
            </button>
            <button class="btn bg-black text-white" (click)="endRound()">
                End
            </button>
            <button class="btn" (click)="nextHole()" *ngIf="this.upcomingHoles.length > 0">
                {{getHoleNumber('holeNumber', upcomingHoles[0].hole.HoleNumber)}}
            </button>
        </div>
        <!-- in-playTop -->

        <!-- conversationHead -->
        <div class="conversationHead d-flex justify-content-end">
            <div class="box bg-white">
                <label>{{"Hole" | translate}}</label>
                <h3>{{currentHole.hole.HoleNumber}}</h3>
            </div>
            <div class="box bg-white">
                <label>{{"Par" | translate }}</label>
                <h3>{{currentHole.par || '--'}}</h3>
            </div>
            <div class="box bg-white">
                <label>{{"Center" | translate}}</label>
                <h3>{{centerDistance | number:'1.0-0'}}
                    {{customSetting.distance === 'yards' ? ('Y' | translate) : ('M' | translate)}}</h3>
            </div>
        </div>
        <!-- conversationHead -->
    </div>

    <!-- conversationCont -->
    <div class="conversationCont row justify-content-center">
        <div class="col-lg-6">
            <!-- conversationChat -->
            <div class="conversationChat" id="conversationChat" (scroll)="onScroll()">
                @if (isLoading || loadingCourseData || loadingMessage) {
                    <div class="course-loading">
                        <span>{{'OnCourseLoadingText' | translate}}</span>
                        <ng-lottie class="black-animation" [options]="animationOptions"/>
                    </div>
                }
                @else {
                <div class="box chatAdmin">
                    <span class="userPrfl"><img [src]="caddyName ? 'assets/images/SpecialCaddy.jpg' : user.caddy.imageUrl" alt=""></span>
                    <div class="txtBlck">
                        <h6>{{caddyName ? caddyName : user.caddy.name}}</h6>
                        @if(caddyName){
                            <p>{{translateOnCourseAdvice1("UnlockCaddieOnCourseAdvice1")}}</p>
                            <p>{{"UnlockCaddieOnCourseAdvice2" | translate}}</p>
                        }
                        @else {
                            <p>{{translateOnCourseAdvice1("OnCourseAdvice1")}}</p>
                        }
                        <p>{{"OnCourseAdvice2" | translate}}</p>
                        <p>{{"OnCourseAdvice3" | translate}}</p>
                        <p>{{"OnCourseAdvice4" | translate}}</p>
                        <p>{{"OnCourseAdvice5" | translate}}</p>
                    </div>
                </div>
                @for(conversation of conversations; track $index){
                    <div class="box">
                        <span class="userPrfl">
                            <img *ngIf="user.imageUrl" [src]="user.imageUrl" alt="">
                            <div class="profile-letter" *ngIf="!user.imageUrl">{{user.name.substring(0, 2).toUpperCase()}}</div>
                        </span>
                        <div class="txtBlck">
                            <h6>You</h6>
                            <p [innerHTML]="conversation.question | formatChat"></p>
                        </div>
                    </div>
                    <div class="box chatAdmin">
                        <span class="userPrfl"><img [src]="caddyName ? 'assets/images/GALogo.jpg' : user.caddy.imageUrl" alt=""></span>
                        @if(conversation.loading) {
                            <img height="50" src="/assets/images/chat-animation.gif" alt="processing">
                        }
                        <div class="txtBlck">
                            <div [innerHTML]="conversation.answer | formatChat"></div>
                            @if(conversation.answer)
                            {
                                <div class="actionBlock mt-2">
                                        <li (click)="addReaction('dislike', $index, conversation.id)">
                                            @if (conversation.reaction === 'dislike'){
                                                <img src="/assets/images/disliked.svg" alt="Dislike">
                                            } @else {
                                                <img src="/assets/images/dislike.svg" alt="Dislike">
                                            }
                                        </li>
                                        <li (click)="addReaction('like', $index, conversation.id)">
                                            @if (conversation.reaction === 'like'){
                                                <img src="/assets/images/liked.svg" alt="Like">
                                            } @else {
                                                <img src="/assets/images/like.svg" alt="Like">
                                            }
                                        </li>
                                        <li>
                                            <a class="cursor-pointer"
                                                (click)="hearAnswer(conversation.answer, $index)">

                                                <ng-container *ngIf="audioAnswerLoading && playingIndex === $index; else checkPlaying">
                                                <img src="assets/images/send-loader.svg" alt="Loading">
                                                </ng-container>

                                                <ng-template #checkPlaying>
                                                <img *ngIf="answerListening && playingIndex === $index; else playIcon"
                                                    src="assets/images/stop.svg"
                                                    alt="Stop"
                                                    class="stop">
                                                </ng-template>

                                                <ng-template #playIcon>
                                                <img src="assets/images/sound.svg" alt="Play">
                                                </ng-template>

                                            </a>
                                        </li>
                                </div>
                                @if(conversation.route === 'rules'){
                                <div class="route-block">
                                    <span>Ask a real rules official</span>
                                    <a href="javascript:void(0)" (click)="openRuleAssistModal(ruleAssistModal, $index)">
                                        <img src="assets/images/ask-blakey-icon.svg" alt="">
                                        {{'Ask Blakey' | translate}}
                                    </a>
                                </div>
                                }
                            }
                        </div>
                    </div>
                }
            }
            </div>
            <!-- conversationChat -->
        </div>
    </div>
    <!-- conversationCont -->

    <!-- bottomBlock -->
    <div class="d-block bottomBlock">
        <div class="voice-block bg-white" [class.disabled]="submitting">
            <div class="equalizer-box" [class.active]="showEqualizer">
                <canvas #equalizerCanvas width="330" height="70"></canvas>
            </div>
            @if(showTextQuestionControl){
                <div class="d-flex align-items-center inputBlockBg bg-white">
                    <input type="text" [(ngModel)]="manualTextQuestion" (keydown.enter)="sendManualTextQuestion()" (blur)="hideTextQuestionControl()" placeholder="Ask anything about golf" #myInput>
                    <button class="btn bg-dark p-0 ms-2 border-0" [disabled]="submitting" (click)="sendManualTextQuestion()">
                        @if (!submitting){
                        <img src="/assets/images/upArw-voice.svg" alt="Enter" style="max-width: 13px;">
                        }
                        @else {
                        <img src="/assets/images/voiceIcon.svg" alt="Use voice mode">
                        }
                    </button>
                </div>
            } @else {
            <div class="d-flex justify-content-between mt-1">
                <div class="caddieAdvice d-flex align-items-center" (click)="(!submitting && !findingLocation) ? callCaddy() :''">
                    <img [src]="caddyName ? 'assets/images/GALogo.jpg' : user.caddy.imageUrl" alt="">
                    <div class="d-flex px-1 justify-content-center text-nowrap w-100">
                        @if(findingLocation){
                            <!-- <img src="assets/images/GeneratingIcon.svg" alt="" class="generateIcon me-1"> -->
                            <span>{{"FindingLocation" | translate}}</span>
                        }
                        @else if(isCallCaddy && isProcessing || this.submitting){
                            <img src="assets/images/GeneratingIcon.svg" alt="" class="generateIcon me-1">
                            <span>{{"Thinking" | translate}}</span>
                        }
                        @else {
                            <span>Caddie Advice</span>
                        }
                    </div>
                </div>
                @if(recordingFinished){
                    <audio #audioRef [src]="audioUrl" (pause)="onPauseOrEnd()" (ended)="onPauseOrEnd()" (play)="onAudioPlay()"></audio>
                    <button [disabled]="submitting"
                        class="btn bg-white p-0 ms-2 play-btn"
                        [disabled]="!recordingFinished || !audioUrl"
                        (click)="isAudioPlaying ? onPause() : onPlay()">
                        <img
                        [src]="isAudioPlaying ? '/assets/images/pause.svg' : '/assets/images/play.svg'"
                        [alt]="isAudioPlaying ? 'Pause' : 'Play'">
                    </button>
                }               
                <div class="d-inline-flex align-items-center">
                    @if (isRecording) {
                        <button (click)="stopRecording()" class="btn bg-white p-0 ms-2">
                            <img src="/assets/images/stop.svg" alt="Stop">
                        </button>
                    } @else if (recordingFinished) {
                        @if(submitting){
                            <button class="btn bg-dark p-0 ms-2 border-0 cursor-pointer">
                                <img src="assets/images/white-loader.svg" alt="">
                            </button>
                        }
                        @else {
                            <button [disabled]="submitting" (click)="closeRecording()" class="btn bg-white p-0 ms-2">
                                <img src="/assets/images/close.svg" alt="Close">
                            </button>
                        }
                       @if(audioBlob){
                            <button [disabled]="submitting" class="btn bg-dark p-0 ms-2 border-0 cursor-pointer" (click)="!submitting ? submitAudioQuestion() : ''">
                                <img src="/assets/images/upArw-voice.svg" alt="Enter">
                            </button>
                         }
                    } 
                    @else {
                        <button class="btn bg-white p-0 ms-2" (click)="startRecording()">
                            <img src="/assets/images/microphone-voice.svg" alt="Microphone">
                        </button>
                        <button class="btn bg-white p-0 ms-2" (click)="showTextQuestionControlInput()">
                            <img src="/assets/images/keyboard.svg" alt="Microphone">
                        </button>
                        <button class="btn bg-white p-0 ms-2" (click)="openSettingModal(roundSettingModal)">
                            <img src="/assets/images/settings-icon.svg" alt="Microphone">
                        </button>
                    }
                 
                </div>
            </div>
            }
        </div>
    </div>
    <!-- bottomBlock -->
</div>
<!-- conversationBg -->
<ng-template #changeUnitModal>
    <div class="row">
        <div class="modal-body">
            <div class="close-btn" (click)="changeUnitModalRef?.dismiss()">
                <img src="assets/images/close_icon.svg" alt="">
            </div>
            <div class="social-title">
                {{"YardsOrMeters" | translate}}
            </div>
            <div class="confirm-body">
                {{"SelectUnit" | translate}}
            </div>

        </div>
        <div class="confirm-footer">
            <button type="button" class="btn custom-button"
                [ngStyle]="{'background-color': customSetting.distance === 'yards' ? 'green' : 'lightgray'}"
                (click)="changeUnit('yards')">{{"Yards" | translate}}</button>
            <button type="button" class="btn custom-button"
                [ngStyle]="{'background-color': customSetting.distance === 'meters' ? 'green' : 'lightgray'}"
                (click)="changeUnit('meters')">{{"Meters" | translate}}</button>
        </div>
    </div>
</ng-template>

<ng-template #roundSettingModal>
    <div class="modal-body text-start">
        <div class="d-flex justify-content-end">
            <a class="cursor-pointer" (click)="saveSettings()">
                <img src="/assets/images/close_icon.svg" alt="Close"> 
            </a>
        </div>
        <h4 class="mb-3">Round Settings</h4>
        <!-- setting box -->
        <div class="settingbox flex-column">
            <drag-scroll class="d-flex">
                <div drag-scroll-item class="card text-center">
                    <!-- Icon -->
                    <div class="d-flex justify-content-center">
                        <div class="icon_bg rounded-circle d-inline-flex align-items-center justify-content-center">
                            <img src="/assets/images/voiceIcon.svg" alt="">
                        </div>
                    </div>
                    <!-- Title -->
                    <h5 class="mt-2">Hands Free ON</h5>
                    <!-- Toggle Buttons -->
                    <div class="btnBg w-100">
                        <button class="btn col" [ngClass]="{'active': customSetting.onCourseAudio === 'on'}"
                            (click)="customSetting.onCourseAudio = 'on'">ON</button>
                        <button class="btn col" [ngClass]="{'active': customSetting.onCourseAudio === 'off'}"
                            (click)="customSetting.onCourseAudio = 'off'">OFF</button>
                    </div>
                    <p class="text-start">
                        Select if the caddie outputs audio response as well as text. We recommend keeping this on for
                        the best experience.
                    </p>
                </div>
                <div drag-scroll-item class="card text-center">
                    <!-- Icon -->
                    <div class="d-flex justify-content-center">
                        <div class="icon_bg bg-white d-inline-flex align-items-center justify-content-center position-relative">
                            <img src="/assets/images/competition_icon.svg" alt="" [ngClass]="{'active': customSetting.onCourseMode === 'competition'}">
                            <img src="/assets/images/social_icon.svg" alt="" [ngClass]="{'active': customSetting.onCourseMode === 'social'}">
                        </div>
                    </div>
                    <!-- Title -->
                    <h5 class="mt-2">Competition</h5>
                    <!-- Toggle Buttons -->
                    <div class="btnBg w-100">
                        <button class="btn col" [ngClass]="{'active': customSetting.onCourseMode === 'competition'}"
                            (click)="customSetting.onCourseMode = 'competition'">Competition</button>
                        <button class="btn col" [ngClass]="{'active': customSetting.onCourseMode === 'social'}"
                            (click)="customSetting.onCourseMode = 'social'">Social</button>
                    </div>
                    <p class="text-start">
                        Competition Mode disables advanced calculations, like slope and weather, to ensure you complies
                        with the Rules of Golf.
                    </p>
                </div>
                <div drag-scroll-item class="card text-center">
                    <!-- Icon -->
                    <div class="d-flex justify-content-center">
                        <div class="icon_bg bg-white d-inline-flex align-items-center justify-content-center">
                            <img src="/assets/images/units_icon.svg" alt="">
                        </div>
                    </div>
                    <!-- Title -->
                    <h5 class="mt-2">Units Meters</h5>
                    <!-- Toggle Buttons -->
                    <div class="btnBg w-100">
                        <button class="btn col" [ngClass]="{'active': customSetting.distance === 'yards'}"
                            (click)="customSetting.distance = 'yards'">Yards</button>
                        <button class="btn col" [ngClass]="{'active': customSetting.distance === 'meters'}"
                            (click)="customSetting.distance = 'meters'">Meters</button>
                    </div>
                    <p class="text-start">
                        Select the unit of measurements when distance is displayed.
                    </p>
                </div>
            </drag-scroll>
        </div>
        <!-- setting box -->
     </div>
</ng-template>
<ng-template #ruleAssistModal>
  <app-rule-assist-modal [ruleAssistQuestionObject]="ruleAssistQuestionObject"
        (closeModal)="closeRuleAssistModal()"></app-rule-assist-modal>
</ng-template>